import React, {useEffect, useContext, useState } from "react";
import {
  Heading,
  Button,
  Input,
  Flex,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import axios from "axios";

import AdminLogin from "../AdminNav/Login";
import { MyContext } from "../../MyProvider";
import { PageHeader, Panel } from "../../components/ui";
import { API_URL } from "../../Apis/config";

const initialLinks = {
  link1: "",
  link2: "",
  link3: "",
  link4: "",
  link5: "",
  link6: ""
};


function YouTube() {
  const {youtubes, youtubesApi} = useContext(MyContext);

  console.log(youtubes);
  const [youtubeLinks, setYoutubeLinks]=useState(initialLinks);

  
  // Fetch existing YouTube links when the component mounts
  
  useEffect(()=>{
 
    setYoutubeLinks({...youtubes})

  },[youtubes])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setYoutubeLinks((prevLinks) => ({
      ...prevLinks,
      [name]: value
    }));
  };

  const handleSave = () => {
    // Make a PUT request to update the YouTube links
    axios
      .put(`${API_URL}/youtube/`, youtubeLinks)
      .then((response) => {
                  
          youtubesApi();

        
      })
      .catch((error) => {
        console.error("Error updating YouTube links:", error);
      });
      
  };
  const token = localStorage.getItem("AdminToken");
  if (!token) {
    return <AdminLogin />;
  }
  return (
    <>
      <PageHeader title="YouTube" subtitle="Video links shown on the website" />
      <Panel p={5} maxW="640px">
        {["link1", "link2", "link3", "link4", "link5", "link6"].map((link, index) => (
          <FormControl key={link} mb={3}>
            <FormLabel>Link {index + 1}</FormLabel>
            <Input
              type="text"
              name={link}
              placeholder={`YouTube Link ${index + 1}`}
              value={youtubeLinks[link]}
              onChange={handleChange}
            />
          </FormControl>
        ))}
        <Button onClick={handleSave} mt={2}>
          Save Links
        </Button>
      </Panel>
    </>
  );
}

export default YouTube;
